import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  useTheme,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useStressEntryContext } from "./StressEntryContext";
import { STRESSOR_CHECK_IN_MODE, STRESSOR_CHECK_OUT_MODE } from "./constants";
import { DateTimePicker } from "@material-ui/pickers";
import { Moment } from "moment";
export const StressExposure = ({ UnitVersion }: any) => {
  const theme = useTheme();
  const { state, dispatch } = useStressEntryContext();
  const [formData, setFormData] = useState({
    exposure: "",
    irradiance: "",
    temperature: "",
    loadType: UnitVersion ==="v12" ? "Open-circuit":"",
    fixed_resistor: "",
    Calibration_date: null as Moment | null

  });

  const [exitFormData, setExitFormData] = useState({

    temperature: "",
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // setFormData(prev => ({   ...prev, [name]: value }));
    setFormData(prev => {

      if (name === "loadType" && value !== "Fixed resistor") {
        return {
          ...prev,
          [name]: value,
          fixed_resistor: "",
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleDateChange = (date: Moment | null) => {
    setFormData(prev => ({ ...prev, Calibration_date: date }));
  };

  const handleExitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setExitFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (UnitVersion === "v12") {
      setFormData(prev => ({
        ...prev,
        loadType: prev.loadType || "Open-circuit", // ✅ default
      }));
    }
  }, [UnitVersion]);

  useEffect(() => {
    const payload = {
      light_exposure: formData.exposure || "",
      irradiance: formData.irradiance ? formData.irradiance : null,
      // average_temperature: formData.temperature ? parseFloat(formData.temperature) : null,
      load_type: formData.loadType || "",
      fixed_resistor_value: formData.fixed_resistor !== "" ? parseFloat(formData.fixed_resistor) : null,
    };
    dispatch({ type: "SET_STRESS_EXPOSURE_DETAILS", payload });
  }, [formData, dispatch, UnitVersion]);

  useEffect(() => {
    if (state.mode === STRESSOR_CHECK_OUT_MODE) {
      const payload = {
        average_temperature: exitFormData.temperature
          ? parseFloat(exitFormData.temperature)
          : null,
      };
      dispatch({ type: "SET_STRESS_OUT_EXPOSURE_DETAILS", payload });
    }
  }, [exitFormData, dispatch, state.mode]);



  return (
    <div >
      {state.mode === STRESSOR_CHECK_IN_MODE && state.isLightSoakCheck && (

        <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="flex-start"
            spacing={2}
            style={{ marginTop: 16, marginBottom: 16 }}
          >
            <Grid item xs={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>


                  <FormControl component="fieldset" required>
                    <FormLabel>Select light exposure method</FormLabel>
                    <RadioGroup
                      name="exposure"
                      value={formData.exposure}
                      onChange={handleChange}
                      row
                    >
                      <FormControlLabel value="Indoor" control={<Radio />} label="Indoor" />
                      <FormControlLabel value="Outdoor" control={<Radio />} label="Outdoor" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    name="irradiance"
                    label="Irradiance Level"
                    value={formData.irradiance}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <DateTimePicker
                    label={"Calibration Date"}
                    format="YYYY-MM-DD"
                    fullWidth
                    value={state.stressCalibrationDate || null}
                    onChange={(date: any) => {
                      dispatch({
                        type: "SET_CALIBRATION_DATE",
                        payload: {
                          date: date || null,
                        },
                      });
                    }}
                  />
                </Grid>

                {UnitVersion !== "v12" && (
                  <Grid item xs={12} style={{ marginBottom: 16, marginTop: 16 }}>
                    <FormControl component="fieldset" required>
                      <FormLabel>Load Type</FormLabel>
                      <RadioGroup
                        name="loadType"
                        value={formData.loadType}
                        onChange={handleChange}
                        row
                      >

                        <FormControlLabel value="Fixed resistor" control={<Radio />} label="Fixed resistor" />
                        <FormControlLabel value="MPPT load" control={<Radio />} label="MPPT load" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                )}


                {UnitVersion === "v12" && (
                  <Grid item xs={12} style={{ marginBottom: 16, marginTop: 16 }}>
                    <TextField
                      select
                      name="loadType"
                      label="Load Type"
                      value={formData.loadType}
                      onChange={handleChange}
                      fullWidth
                      required
                    >
                      <MenuItem value="Fixed resistor">Fixed resistor</MenuItem>
                      <MenuItem value="MPPT load">MPPT load</MenuItem>
                      <MenuItem value="Open-circuit">Open-circuit OC</MenuItem>
                      <MenuItem value="Short-circuit">Short-circuit SC</MenuItem>
                    </TextField>
                  </Grid>
                )}


                {formData.loadType === "Fixed resistor" && (
                  <Grid item xs={12}>
                    <TextField
                      name="fixed_resistor"
                      label="Fixed resistor Value"
                      value={formData.fixed_resistor || ""}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>
                )}

              </Grid>
            </Grid>

          </Grid>
        </Paper>
      )}

      {state.mode === STRESSOR_CHECK_OUT_MODE && state.isLightSoakCheck && (
        <>
          <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
            <Grid
              container
              direction="row"
              justifyContent="space-around"
              alignItems="flex-start"
              spacing={2}
              style={{ marginTop: 16, marginBottom: 16 }}
            >
              <Grid item xs={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      name="temperature"
                      label="Average Temperature"
                      value={exitFormData.temperature}
                      onChange={handleExitChange}
                      fullWidth
                    />

                  </Grid>

                </Grid>
              </Grid>
            </Grid>
          </Paper>

        </>
      )}
    </div>
  );
};